import InfoIcon from '@mui/icons-material/Info';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export interface ApplicationFormProps {
  appName: string;
  clientId: string;
  developerEmail: string;
}

export function ApplicationInfo({ appName, clientId, developerEmail }: ApplicationFormProps) {
  return (
    <>
      <Typography variant="h3" gutterBottom data-test="authorize-app-text">
        Authorize application
      </Typography>
      <TableContainer>
        <Table size="small" padding="checkbox" sx={{ marginBottom: 2, tableLayout: 'fixed' }}>
          <TableBody>
            <TableRow data-test="application-name-row">
              <TableCell component="th" scope="row">
                Application name
              </TableCell>
              <TableCell>
                {appName}
                <Tooltip title={`Client id: ${clientId}`} placement="right" sx={{ marginLeft: 1 }}>
                  <InfoIcon />
                </Tooltip>
              </TableCell>
            </TableRow>
            <TableRow data-test="developer-email-row">
              <TableCell component="th" scope="row">
                Developer email
              </TableCell>
              <TableCell>{developerEmail}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
